import { createEffect, Effect } from 'effector'
import { dataLayerPush, fbq } from '~/processes/helpers/tracking'

const SIGN_UP_FORM_EVENT_NAME = 'sign_up_form'

export const seoTrackingSignUpFx: Effect<void, void> = createEffect<void, void>(
  () => {
    fbq({ action: 'trackCustom', eventName: SIGN_UP_FORM_EVENT_NAME })
    dataLayerPush(SIGN_UP_FORM_EVENT_NAME)
  }
)
